import React from 'react';
import './FocusHero.scss';
function FocusHero({ title, backgroundImageUrl }) {
    return (React.createElement("div", { className: "focus-hero" },
        React.createElement("div", { className: "focus-hero__content", style: { backgroundImage: `url(${backgroundImageUrl})` } },
            React.createElement("h1", null, title))));
}
export default FocusHero;
